"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { carrierInvoiceWithLoadPath } from "../flow_mode/dashboard_paths";
import loadHelper from "../loads";
import { push } from "../app_history";
function renderReconcileInvoiceStep(props) {
  const clickEnabled = !loadHelper.isMovedToTmsQueue(props.invoice);
  const classes = classNames({
    "indexer-progress__item": true,
    "indexer-progress__item--clickable": clickEnabled,
    "indexer-progress__item__completed": true
  });
  const onClick = clickEnabled ? () => redirectToReconcileInvoicePage(props) : void 0;
  return /* @__PURE__ */ jsxs("li", { className: classes, onClick, children: [
    /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator-inner" }) }),
    /* @__PURE__ */ jsx("span", { children: "Reconcile Invoice" }),
    /* @__PURE__ */ jsx("hr", { className: "indexer-progress__trailer" })
  ] });
}
function redirectToReconcileInvoicePage(props) {
  const url = carrierInvoiceWithLoadPath(
    props.invoice.load_state_id,
    props.invoice.id,
    true
  );
  push(url.pathString(), {
    onDone: props.location.query.onDone
  });
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
  }
  render() {
    return /* @__PURE__ */ jsx("div", { className: "document-indexer__progress", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__container-ltl-reconcile", children: /* @__PURE__ */ jsxs("ul", { className: "indexer-progress__list", children: [
      renderReconcileInvoiceStep(this.props),
      /* @__PURE__ */ jsxs("li", { className: "indexer-progress__item indexer-progress__item--clickable indexer-progress__item__active", children: [
        /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator-inner" }) }),
        /* @__PURE__ */ jsx("span", { children: "Review and Submit" })
      ] })
    ] }) }) });
  }
}
